var idx = 0;
function checkAnimation() {
    var baseDelay = 500;
    idx = 0;
    $('.in-hide').each(function(){
        var self = $(this);
        if (self.visible(true))
        {
            idx++;
            setTimeout(function () {
                self.removeClass('in-hide');
                self.addClass('in-view');
            }, baseDelay * idx);
        }
        else if (! self.visible(true) && (self.offset().top > $(window).scrollTop())) {
            setTimeout(function () {
                self.removeClass('in-view');
                self.addClass('in-hide');
            }, baseDelay * idx);
        }
    });
}
$(document).ready(function(){
    checkAnimation();
    $(window).scroll(function(){
        checkAnimation();
    })
});